if (!customElements.get('duckunique-personalization')) {
  customElements.define('duckunique-personalization', class extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input[type="file"]');
      if (!input || this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      input.addEventListener('change', () => {
        input.setCustomValidity('');
        const file = input.files?.[0];
        if (!file) return;
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
          input.setCustomValidity(input.dataset.typeError);
        } else if (file.size > 10 * 1024 * 1024) {
          input.setCustomValidity(input.dataset.sizeError);
        }
        input.reportValidity();
      });
    }
  });
}
